











import Vue from "vue";
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: "更新",
    },
    size: {
      type: String,
      default: "",
    },
    radius: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleOnClick() {
      this.$emit("click");
    },
  },
});
